import { gql } from "@apollo/client";

export const GET_BANK_HOLIDAYS = gql`
  query GetBankHoliday(
    $take: Int
    $where: BankHolidayWhereInput
    $orderBy: [BankHolidayOrderByWithRelationInput!]
  ) {
    getBankHoliday(take: $take, where: $where, orderBy: $orderBy) {
      beginDate
      endDate
    }
  }
`;
